export const ELEMENT_STATE = {
  none: '7b72b8f5-a003-4322-af05-15406fc462fa',
  created: '0844b4a8-89c9-4c14-a1b7-050f81a6d012',
  activating: 'c31f0dbf-c4d9-4ee0-93fd-eb294579de08',
  diverted: '754a1bc1-bba3-4368-87c6-fbc139a378e0',
  active: '3f274f41-0e85-4b2e-99a5-df791ac1ade8',
  conferenced: '8e2428c1-d7a0-434c-b355-41367dc00ab2',
  forwarded: 'c30706c2-1e5a-4fe2-870f-44d0da714cd3',
  returned: '3c026b08-2aae-4245-b290-eabb711ba78f',
  closed: '16612011-504e-4a26-be5c-550c879a27ce',
  abandoned: '657e3ffb-a10a-4faa-8bd5-3de7d75629ec',
  failed: '720fa083-909f-477e-aff3-b69d4d09a01a',
  conferencedDiverted: 'd0fc7852-2f5f-4dea-b777-f1b43d87a268',
  noAnswer: 'f557a1cf-e87e-45d1-8359-7ecc82196eb3',
  busy: '952aafc8-8275-406c-845a-7c78b8f39433',
  unreachableDestination: '0a2b2e6f-d492-4631-8682-bc48b7aa103c',
  callBack: 'd725bd86-641b-416b-98c3-a83c0139e313',
  waitingCall: 'b6837e90-bff1-4e33-a52b-72c835b0b9b3',
  faxDetected: 'c7e50a85-ba39-44ef-800c-9fb0c4b18cb0',
  answeringMachine: 'cdb5dcfd-c38d-4836-808e-6c6612deb0a6',
  serviceUnavailable: '045133d2-ec13-4b67-8e35-bcb238b4306f',
  canceled: '19eb3eaf-7522-4ddc-ad00-93a784691684',
  cpaTimeout: 'acba98aa-7049-4206-a42c-c9fd888c112c'
};
